import { render, staticRenderFns } from "./base-crud-table.vue?vue&type=template&id=4027ff06&"
import script from "./base-crud-table.vue?vue&type=script&lang=js&"
export * from "./base-crud-table.vue?vue&type=script&lang=js&"
import style0 from "./base-crud-table.vue?vue&type=style&index=0&id=4027ff06&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports